import { CreateLabelText } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/AbstractScrollableContentView";
import { VerticalLayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/layout/VerticalLayout";
import { BasePaytableComponent } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/BasePaytableComponent";
import { BetData, LabelText, PayListEntryValueEntries } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/PaytableContent";
import { IOryxServiceProvider } from "@westpierstudio/core-module-oryx/game";
import { defaultCurrencyConfig } from "@westpierstudio/core-module-oryx/services/currency/configs";
import { TextFromContainer } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utils";
import { View } from "@westpierstudio/luma/mvc";
import { Container } from "pixi.js";
import { convertDisplayObjectToImage } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utilsImg";

export class SpreadRTPComponent extends BasePaytableComponent {

    verticalLayout = new VerticalLayout({ gap: 10 });

    titleText = ``;
    descriptionText = ``;
    spreadRTPEntryView: SpreadRTPEntryView;

    constructor(services: IOryxServiceProvider, payload: SpreadRTPPayload, protected spreadRTPEntries: SpreadRTPEntry[], createLabelText: CreateLabelText) {
        super(services);

        if (payload === undefined) {
            payload = {};
        }

        if (payload.title) {
            this.verticalLayout.add(createLabelText(payload.title, 0.5, 0, false));
            this.titleText = payload.title.label;
        }

        if (payload.content) {
            this.verticalLayout.add(createLabelText(payload.content, 0.5, 0, true));
            this.descriptionText = payload.content.label;
        }

        const spreadEntryView = new SpreadRTPEntryView(
            services,
            spreadRTPEntries.map((entry, i) => ({
                count: {
                    label: `${services.currency.formatCoinsUI(entry.betAmount, { useSubUnits: true })}${i === spreadRTPEntries.length - 1 ? `+` : ``}`,
                    style: payload.betStyle ? payload.betStyle : `paragraphStyle`
                },
                value: {
                    label: `${services.currency.format(entry.rtp, { ...defaultCurrencyConfig, trimIntegers: false })}%`,
                    style: payload.rtpStyle ? payload.rtpStyle : `paragraphStyleYellow`
                },
            })),
            createLabelText
        );

        this.verticalLayout.add(spreadEntryView);
        this.spreadRTPEntryView = spreadEntryView;

        this.verticalLayout.layout(this);
    }

    async getRenderedContentAsText(): Promise<ReadonlyArray<TextFromContainer>> {
        const img = await convertDisplayObjectToImage(this.services.application.renderer, this.spreadRTPEntryView, `image/png`);
        return [{ title: this.titleText, content: this.descriptionText, images: [img] }];
    }

    onOpen(betData: BetData): void { }
    updateLayout(width: number, height: number): void { }
}

export class SpreadRTPEntryView extends View {

    textContainer: Container;

    constructor(
        protected override services: IOryxServiceProvider,
        rows: PayListEntryValueEntries[],
        createLabelText: CreateLabelText
    ) {
        super(services);

        this.textContainer = new Container();
        this.addChild(this.textContainer);

        let posY = 0;

        const inDescending = (valuea: number, valueb: number) => +valueb - +valuea;
        const valuesSorted = rows.slice().sort((valuea, valueb) => inDescending(+valuea.count, +valueb.count));

        const entries = valuesSorted.map(({ count, value }) => {
            let countText = undefined;
            if (count) {
                countText = createLabelText(count);
                countText.position.y = posY;
                this.textContainer.addChild(countText);
            }
            let valueText = undefined;
            if (value) {
                value.label = value.label;
                valueText = createLabelText(value);
                valueText.position.x = countText ? countText.position.x + countText.width + 6 : 0;
                valueText.position.y = posY;
                this.textContainer.addChild(valueText);
            }
            if (valueText) {
                posY += valueText.height + 4;
            } else if (countText) {
                posY += countText.height + 4;
            } else {
                posY += 4;
            }

            return {valueText, countText};
        });

        const farthestRightRTP = entries.reduce((x, {valueText}) => {
            if (!valueText) {
                return x;
            }
            return valueText.x > x ? valueText.x : x;
        }, 0);

        entries.forEach(({valueText}) => {
            if (valueText) {
                valueText.x = farthestRightRTP;
            }
        });

        this.repositionText();
    }

    repositionText() {
        this.textContainer.position.x = -this.textContainer.width / 2;
    }
}

export type SpreadRTPEntry = {
    betAmount: number,
    rtp: number
}

export type SpreadRTPPayload = {
    betStyle?: string
    rtpStyle?: string,
    title?: LabelText,
    content?: LabelText
}

export type SubRTPVariants = {
    smallSpin: {
        betSize1: number
    },
    spin: {
        betSize1: number,
        betSize2: number,
        betSize3: number,
        betSize4: number,
        betSize5: number
    }
}